import React from 'react';
import {
  Paper,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Box,
  OutlinedInput,
} from '@mui/material';
import { formatCurrency } from './helpers';

const PartnerSelector = ({
  title,
  partnerType,
  selected,
  onChange,
  filteredLocations = [],
  selectedSiteTypes = [],
  partners = {}
}) => {
  // Get available partner options for the given partner type
  const getPartnerOptions = () => {
    if (!partners[partnerType] || Object.keys(partners[partnerType]).length === 0) {
      return ['NA'];
    }
    return Object.keys(partners[partnerType]);
  };

  const options = getPartnerOptions();
  const isDisabled = options.length === 1 && options[0] === 'NA';

  // Calculate total sites that match the selected site types
  const totalFilteredSites = filteredLocations.filter(
    loc => selectedSiteTypes.includes(loc.size)
  ).length;

  // Calculate annual cost for the selected partner
  const calculatePartnerCost = (partnerName) => {
    if (partners[partnerType]?.[partnerName]) {
      return partners[partnerType][partnerName].pricePerYear * totalFilteredSites;
    }
    return 0;
  };

  // Modified to handle single selection
  const handleChange = (event) => {
    const value = event.target.value;
    if (value !== 'NA') {
      onChange(event);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 1.5, mt: 1 }}>
      <Typography variant="subtitle2" gutterBottom>
        {title}
      </Typography>
      <FormControl fullWidth>
        <Select
          value={selected || ''} // Changed from array to single value
          onChange={handleChange}
          input={<OutlinedInput />}
          disabled={isDisabled}
        >
          <MenuItem value="">None</MenuItem>
          {options.map((option) => (
            <MenuItem key={option} value={option} disabled={option === 'NA'}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Cost Display Section */}
      {selected && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {selected}: {formatCurrency(calculatePartnerCost(selected))} / year
          </Typography>
          <Typography variant="caption" display="block" sx={{ ml: 1 }}>
            ({totalFilteredSites} sites × ${partners[partnerType]?.[selected]?.pricePerYear}/site/year)
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default PartnerSelector;